/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './AggregatePerformanceCard.scss';

import { bool, object } from 'prop-types';
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import BaseCard from 'components/shared/Card/BaseCard';
import { EvaluatedPercent } from 'components/shared/Text/Text';
import CardDisclosureModal from 'components/shared/Disclosure/CardDisclosureModal';
import Content from 'services/Content';

const AggregatePerformanceCard = ({ data, hasError, isLoading }) => {
  const { showTotalPerformance, inceptionReturn } = data;

  if (!showTotalPerformance || isLoading || hasError) {
    return null;
  }

  const footer = (
    <Fragment>
      <Link
        className="card-action-link"
        to="/performance#personal-rate-of-return">
        View Details
      </Link>
      <CardDisclosureModal
        className="restricted-height-modal"
        content={Content.prrPerformanceDisclosure}
      />
    </Fragment>
  );

  return (
    <BaseCard
      isLoading={isLoading}
      title="Personal Rate of Return (PRR)"
      footer={footer}
      className="standard aggregate-performance-card-container">
      <div className="aggregate-performance-card">
        <p>Total Return Since Inception</p>
        <EvaluatedPercent className="aggregate-performance-card-value">
          {inceptionReturn}
        </EvaluatedPercent>
      </div>
    </BaseCard>
  );
};

AggregatePerformanceCard.propTypes = {
  data: object,
  hasError: bool,
  isLoading: bool
};

export default AggregatePerformanceCard;
